/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'refresh': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" _fill="#C4FFF9" d="M104.602 114.398L89.2 91.5c-.8-1.2.102-2.898 1.602-2.898h8.3V50.2H68.7V36h37.5c3.899 0 7.102 3.2 7.102 7.102v45.5h8.3c1.5 0 2.4 1.7 1.602 2.899L107.7 114.399c-.699 1.101-2.398 1.101-3.097 0l-.001-.001zM50.899 99.8V61.398h8.3c1.5 0 2.4-1.7 1.602-2.898L45.4 35.602c-.699-1.102-2.398-1.102-3.101 0L26.9 58.5c-.801 1.199.101 2.898 1.601 2.898h8.301v45.5c0 3.898 3.2 7.102 7.102 7.102h37.5L81.4 99.8H50.899z"/>'
  }
})
